import { Balloon, Cake } from "react-bootstrap-icons";
import { usePage } from "../services/PageContext";
import "./BirthdayGreeting.scss"
import { useAuth } from "../services/AuthContext";


export default function BirthdayGreeting (){
  const { isMobileStyle } = usePage()
  const { user } = useAuth();
  
  return (
    <div className= {`birthday-congrats purple-header  confirmed ${isMobileStyle ? 'is-mobile' : ''}`}>
      <div className="congrats"></div>
      <div className='content'>
        <div className='title'>
          <Balloon />
          {user.name}, Feliz Cumpleaños!
          <Cake />
        </div>
        <div className='subtitle'>Te deseamos que tengas una hermosa semana!</div>
      </div>
      <div className="congrats congrats-right"></div>
    </div>
  )
}